import { useTranslation } from 'react-i18next';
import { Box, Button, CircularProgress, useTheme } from '@mui/material';
import { AddRounded as AddIcon } from '@mui/icons-material';
import { FlowExplorer } from '../../../Components/FlowExplorer/FlowExplorer';
import { FLOW_BUILDER2_PAGE_NS } from '../../../i18n';
import { useAddStep } from '../../../Support/useAddStep';
import { useFlowBuilder2PageStore } from '../../../Store/useFlowBuilder2PageStore';
import { isEqual } from 'lodash';
import {
  useAssistantLoadingStore,
  AdvancedEditorItemTypeEnum,
  useEditorStore,
  FlowResourceType,
} from '@diana/core';
import { BuilderTypeEnum } from '../../../Store/FlowBuilder2PageStore.types';
import { AeSidebarContent } from '../AeSidebar/AeSidebarContent';
import { AeCreateStepFooter } from '../AeSidebar/AeCreateStepFooter';

export const Explorer = () => {
  const { palette } = useTheme();

  const isAdvancedEditorOpened = useFlowBuilder2PageStore(
    (store) => store.builderType === BuilderTypeEnum.AdvancedEditor,
  );
  const isAssetType = useEditorStore(
    (store) => store.flow?.properties.flowResourceType === FlowResourceType.Entity,
  );

  return (
    <>
      <Box display={isAdvancedEditorOpened ? 'none' : 'block'} pb={isAssetType ? 1 : 0}>
        <FlowExplorer />
        {!isAssetType ? (
          <Box width="100%">
            <ExplorerFooter />
          </Box>
        ) : null}
      </Box>

      {isAdvancedEditorOpened && (
        <Box pb={1}>
          <AeSidebarContent keepItemsByType={[AdvancedEditorItemTypeEnum.Steps]} />
          {!isAssetType ? (
            <Box width="100%" position="sticky" bottom={-1} bgcolor={palette.background.paper}>
              <AeCreateStepFooter />
            </Box>
          ) : null}
        </Box>
      )}
    </>
  );
};

export const ExplorerFooter = () => {
  const { t } = useTranslation(FLOW_BUILDER2_PAGE_NS);

  const hasAnyPendingStatus = useFlowBuilder2PageStore((s) => s.hasAnyPendingStatus(), isEqual);
  const isChatLoading = useAssistantLoadingStore((state) => state.isLoading);

  const disabled = hasAnyPendingStatus || isChatLoading;

  const { addStep, isAddingStep } = useAddStep();

  return (
    <Box py={0.5}>
      <Button
        style={{ justifyContent: 'left', textTransform: 'none', height: 32, borderRadius: '6px' }}
        disabled={isAddingStep || disabled}
        startIcon={
          isAddingStep ? (
            <CircularProgress size="1em" />
          ) : (
            <AddIcon color={disabled ? 'secondary' : 'primary'} />
          )
        }
        onClick={addStep}
        fullWidth
      >
        {t('buttons.addStep')}
      </Button>
    </Box>
  );
};
